import AppWrapper from "../../../components/cm/AppWrapper";
import SideBarMain from "../../../components/cm/SideBarMain";
import UploadDocuments from "../../../components/modules/Documents/UploadDocuments";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <UploadDocuments />
    </AppWrapper.WithSidebar>
  );
};
